// Copyright (c) 2020 Deere & Company

import React, {PropTypes} from 'react';
import Favorite from '@deere/cps-it.warranty-model-factory/lib/favorite';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router';

const FavoriteslistItem = props => <li>
    <span
        className='favorite-list-item-active'
        onClick={() => props.onFavoriteshandler(props.item)}
    ></span>
    <Link
        to={props.to}
    ><FormattedMessage id={props.item}/>
    </Link>
</li>;

FavoriteslistItem.displayName = 'FavoriteslistItem';
FavoriteslistItem.propTypes = {
    item: PropTypes.instanceOf(Favorite).isRequired,
    onFavoriteshandler: PropTypes.func.isRequired,
    to: PropTypes.instanceOf(Favorite).isRequired
};
export default FavoriteslistItem;



// WEBPACK FOOTER //
// ./src/shared/components/favorites/favorite-list-item.js